<template>
  <div>
    <h1>Video List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <p>
      <router-link
        :to="{ name: 'VideoCreate' }"
        class="btn btn-primary">Create</router-link>
    </p>

    <table class="table table-responsive table-striped table-hover">
      <thead :key="keyComponent">
        <tr>
          <th>Id</th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Name
              <div @click="sortByName">
                <span
                  v-if="sortName == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Created
              <div @click="sortByCreated">
                <span
                  v-if="sortCreated == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>Youtube Video Id</th>
          <th>Speaker</th>    
          <th>Testimonials</th>
          <th>View</th>
          <th>Edit</th>          
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in videoItems"
          :key="item['@id']">
          <th scope="row">
            <router-link
              v-if="item"
              :to="{name: 'VideoShow', params: { id: item['@id'] }}">
              {{ item['id'] }}
            </router-link>
          </th>
        <td>
            {{ item['name'] }}
        </td>
        <td>
            {{ item['created'] }}
        </td>
        <td>
            {{ item['youtubeVideoId'] }}
        </td>
        <td v-if="item['speaker'] != null">
            {{ item['speaker'].name }}
        </td>
        <td v-else>          
        </td>   
        <!-- <td>
            {{ item['testimonials'] }}
        </td> -->
        <td>
            <template v-if="item['testimonials'] != ''">
              <!-- <div
                v-if="Array.isArray(item['testimonials'])">
                <router-link
                  v-for="link in item['testimonials']"
                  :key="link['@id']"
                  :to="`/testimonials/show/${link['@id']}`">
                  {{ link['@id'] }}
                </router-link>
              </div> -->
              <router-link                              
                :to="{ name: 'TestimonialListVideo', params: { id: item['id'] }}">
                {{ item['testimonials'].length }}
              </router-link>
            </template>
        </td>
          <td>
            <router-link
              :to="{name: 'VideoShow', params: { id: item['@id'] }}">
              <span
                class="fa fa-search"
                aria-hidden="true"></span>
              <span class="sr-only">Show</span>
            </router-link>
          </td>
          <td>
            <router-link :to="{name: 'VideoUpdate', params: { id: item['@id'] }}">
              <span
                class="fas fa-edit"
                aria-hidden="true"></span>
              <span class="sr-only">Edit</span>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <nav class="my-3" aria-label="Page navigation" v-if="view">
      <router-link
        :to="view['hydra:first'] ? view['hydra:first'] : 'VideoContactList'"
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&lArr;</span> <span class="d-none d-sm-inline">First</span>
      </router-link>
      &nbsp;
      <router-link
        :to="!view['hydra:previous']? 'videos' : view['hydra:previous']"        
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&larr;</span> <span class="d-none d-sm-inline">Previous</span>
      </router-link>

      <router-link
        :to="view['hydra:next'] ? view['hydra:next'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Next <span aria-hidden="true">&rarr;</span>
      </router-link>

      <router-link
        :to="view['hydra:last'] ? view['hydra:last'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Last <span aria-hidden="true">&rArr;</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {
      successMessage: false,
      errorMessage: false,
      videoItems: null,
      sortName: null,
      sortCreated: null,
      sortField: null,
      keyComponent: 1
    }
  },
  computed: {
      ...mapFields('video/del', {
          deletedItem: 'deleted',
      }),
      ...mapFields('video/list', {
          error: 'error',
          items: 'items',
          isLoading: 'isLoading',
          view: 'view',
      }),     
      ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
      }),
      routePath(){
        return this.$route.fullPath;
      },
      routeParams(){  
        return this.$route.params;
      },
      routeQuery() {
        return this.$route.query;
      },
  },
  created() {
    if (localStorage.getItem('sortNameVideo')) {
      this.sortName = localStorage.getItem('sortNameVideo');
      this.sortField = { field: 'name', order: this.sortName };
    }
    if (localStorage.getItem('sortCreatedVideo')) {
      this.sortCreated = localStorage.getItem('sortCreatedVideo');
      this.sortField = { field: 'created', order: this.sortCreated };
    }
    if (!localStorage.getItem('sortNameVideo') && !localStorage.getItem('sortCreatedVideo')) {
      this.sortCreated = 'asc'
      this.sortField = { field: 'created', order: this.sortCreated };
    }
  },
  mounted() {                 
    this.fetchVideos();    
    this.speakersGetSelectItems();

    if (this.routeParams.success) {
      this.successMessage = this.routeParams.success;
    } else if (this.routeParams.error) {
      this.errorMessage = this.routeParams.error;
    } else {
      this.successMessage = false;
      this.successMessage = false;
    }   
  },
  watch:{
    routePath(){
      this.getSortedPage({field: this.sortField.field, order:this.sortField.order, page: this.routeQuery.page})
    },
    items() {
      this.videoItems = this.items;      
    }
  },
  methods: {
    ...mapActions({
      getPage: 'video/list/default',
      getSortedPage: 'video/list/getSortedItems',
      speakersGetSelectItems: 'speaker/list/getSelectItems',
    }),    
    sortByName() {
      // Remove other filters 
      this.sortCreated = null;
      localStorage.removeItem("sortCreatedVideo");      

      // Filter
      if (this.sortName == 'desc') {
        this.sortName = 'asc';
      } else if (this.sortName == 'asc') {
        this.sortName = 'desc';
      } else {
        this.sortName = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortNameVideo", this.sortName);
      this.sortField = { field: 'name', order: this.sortName };
      this.fetchVideos();
      
      // Refresh header
      this.keyComponent += 1;
    },
    sortByCreated() {      
      // Remove other filters
      this.sortName = null;
      localStorage.removeItem("sortNameVideo");      

      // Filter
      if (this.sortCreated == 'desc') {
        this.sortCreated = 'asc';
      } else if (this.sortCreated == 'asc') {
        this.sortCreated = 'desc';
      } else {
        this.sortCreated = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortCreatedVideo", this.sortCreated);
      this.sortField = { field: 'created', order: this.sortCreated };       
      this.fetchVideos();      

      // Refresh header
      this.keyComponent += 1;
    },
    fetchVideos() {
      if (this.routeQuery && this.routeQuery.page) {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order, page: this.routeQuery.page});
      } else {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order})
      }    
    }
  },
};
</script>
<style lang="scss">
  @media only screen and (min-width: 992px) {
    .table {
      display: table;            
    }
  } 
</style>


// WEBPACK FOOTER //
// src/components/video/List.vue